export enum UserType {
  GUEST = 'guest',
  CANDIDATE = 'candidate',
  EMPLOYER = 'employer',
  INTERNAL = 'internal',
}
